export default __webpack_public_path__ + "static/media/logo_White_NT.de1c9ee5.png";